import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, delay, map, retryWhen, take, tap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { AuthorAPIResponse } from '../../interface/author.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthorService {
  private token: string;
  private url = environment.url;


  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) {
    this.token = localStorage.getItem('token');
  }

  getAuthorInfo(): Observable<AuthorAPIResponse> {
    return this.http.get<AuthorAPIResponse>(`${this.url}/api/author/info`);
  }

  logout(): Observable<any> {
    return this.http.post<any>('/logout', this.token);
  }

  redirectLogout(): void {
    localStorage.clear();
    window.location.href = `${environment.identity_url}/signout?redirect_uri=${environment.base_url}`;
  }

  getImageCookie(url: string) {
    return this.http.get(url, {observe: 'response'}).pipe(
      tap(response => this.setCookie(response.headers.get('set-cookie'))), 
      retryWhen(err => err.pipe(delay(500), take(10))),
      catchError((err: HttpErrorResponse) => throwError(err))
    );
  }

  setCookie(cookie: string) {
    this.document.cookie = cookie;
  }
}
